import type { Contract, STDocument, STOpenFolderState } from '@st/sdk'
import { match, P } from '@st/pattern'

export function contractDocumentId(contract: Contract) {
  return match(contract)
    .with({ status: 'draft' }, ({ source }) => source.documentId)
    .with(
      { status: 'published', publishedDocumentId: P.string },
      ({ publishedDocumentId }) => publishedDocumentId
    )
    .with(
      { status: 'submitted', submittedDocumentId: P.string },
      ({ submittedDocumentId }) => submittedDocumentId
    )
    .otherwise(() => {
      throw new Error(`Missing document for ${contract.status} contract ${contract.id}`)
    })
}

export function contractForDocument(contract: Contract | undefined, documentId: string) {
  if (contract != undefined && contractDocumentId(contract) == documentId) {
    return contract
  }
  return undefined
}

export function documentContract(
  folderState: Pick<
    STOpenFolderState,
    'engagementLetter' | 'taxReturnDelivery' | 'taxReturnDeliveryDrafts'
  >,
  document: STDocument
): Contract | undefined {
  return [
    folderState.engagementLetter,
    folderState.taxReturnDelivery,
    ...folderState.taxReturnDeliveryDrafts
  ].find((contract) => contractForDocument(contract, document.id))
}
